export { ErrorCollectComponent } from './error-collect.component';
export { AdErrorCollectModule } from './error-collect.module';
